import React from 'react';
import { Box, IconButton, Link, Typography, Divider } from '@mui/material';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ArrowBack, ArrowForward } from '@mui/icons-material';



import webtexts from '../../assets/webtexts.json';
import {celeste_5} from '../../assets/images/projects/celeste'
import {hive_1} from '../../assets/images/projects/hive'
import {jackson_3} from '../../assets/images/projects/jackson'
import {twc_2} from '../../assets/images/projects/the-new-chapter'
import {vine_10} from '../../assets/images/projects/vine'
import {waterfront_10} from '../../assets/images/projects/waterfront'
import {madrona_15} from '../../assets/images/projects/madrona'

const Portfolio = ({sx}) => {
    const projects = [
        {name: 'Celeste Residence', image: celeste_5, path: 'celeste-residence', text:webtexts.projects.find(item => item.id === 'celeste')?.intro},
        {name: 'Hive II', image: hive_1, path: 'hive', text:webtexts.projects.find(item => item.id === 'hive')?.intro},
        {name: "Jackson House", image: jackson_3, path: 'jackson-house', text:webtexts.projects.find(item => item.id === 'jackson')?.intro},
        {name: 'The New Chapter', image: twc_2, path: 'the-new-chapter', text:webtexts.projects.find(item => item.id === 'tnc')?.intro},
        {name: 'Vine', image: vine_10, path: 'vine', text:webtexts.projects.find(item => item.id === 'vine')?.intro},
        {name: 'Waterfront Eye Wear', image: waterfront_10, path: 'waterfront-eye-wear', text:webtexts.projects.find(item => item.id === 'waterfront')?.intro},
        {name: 'Madrona', image: madrona_15, path: 'madrona', text:webtexts.projects.find(item => item.id === 'madrona')?.intro}
      ]

      const CustomArrows = ({ onClick, direction }) => (
        <IconButton
          aria-label={direction === 'left' ? 'Previous' : 'Next'}
          onClick={onClick}
          sx={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
            backgroundColor: 'rgba(255,255,255,0.5)',
            borderRadius: '50%',
            width: 40,
            height: 40,
            cursor: 'pointer',
            ...(direction === 'left' ? { left: 0 } : { right: 0 })
          }}
        >
          {direction === 'left' ? <ArrowBack /> : <ArrowForward />}
        </IconButton>
      );

      const settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 3,
        speed: 2000,
        swipe:true,
        autoplay: true, // Enable auto-play
        autoplaySpeed: 1000,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerPadding:'50px'
              // centerMode: false // Disable center mode on smaller screens
            }
          }
        ],
        prevArrow: <CustomArrows direction='left' />,
        nextArrow: <CustomArrows direction='right' />
      };
    
      
  return (
    <Box
      sx={{
        background:'linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0), rgba(0, 0, 0, 1))',
        paddingTop:'5rem',
        ...sx
      }}
    >
        <Box
          sx={{
            
          }}
        >
          <Box 
            sx={{
              // paddingY:'1rem'
            }}
          >
            <Typography
              variant='h1'
              sx={{
                fontSize:'2.5rem',
                fontFamily:"var(--title-font)",
                fontWeight:'500',
                textAlign:'center',
                cursor: 'pointer',
                color:'#ffffff',
                paddingY:'2rem'
              }}
            >Featured <span style={{color:'#C4c7f0', fontWeight:'1000'}}>Projects</span></Typography>
          </Box>
            <Box
                className="slider-container"
                sx={{
                    margin:'auto',
                    width:'90%',
                    alignContent:'center',
                    alignItems:'center',
                    justifyContent:'space-evenly',
                    
                }}
            >
                <Slider {...settings}>
                    {projects.map((project, index) => (
                      <Box
                        key={index}
                        sx={{
                          
                        }}
                      >
                        <Box // slides
                          sx={{
                            minHeight:'40vh',
                            backgroundImage:`url(${project.image})`,
                            margin:'1rem',
                            backgroundPosition:'center center',
                            backgroundSize:'cover',
                            transition:'transform 0.5s ease',
                            '&:hover':{
                              transform:'scale(1.1)',
                              border:'1px solid black'
                            }
                          }}
                        >

                        </Box>

                        <Box
                          sx={{
                            margin:'1rem',
                            textAlign:'center'
                          }}
                        >
                          <Link
                            href={`/projects/${project.path}`}
                            sx={{
                              textDecoration:'none',
                              color:'#000'
                            }}
                          >
                            <Typography
                              variant='h3'
                              sx={{
                                fontFamily:"var(--title-font)",
                                fontStyle:'normal',
                                fontWeight:'500',
                                fontSize:'2rem',
                                cursor: 'pointer',
                                color:'#fefefe',
                                '&:hover':{
                                  color:'#59428A'
                                }
                              }}
                            >{project.name}</Typography>
                          </Link>
                          <Typography
                            sx={{
                              fontFamily: "var(--text-font)",
                              textAlign:'center',
                              color:'#fefefe'
                            }}
                          >{project.text}</Typography>
                        </Box>
                      </Box>
                    ))}
                </Slider>
            </Box>
        </Box>
    </Box>
  );
};

export default Portfolio